/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { useTranslations } from '../../hooks/useTranslations';
import { uiButtonIconMediumSize, uiFullWidth, uiFullHeight } from '../../Styling/Theme/Theme';
import { Icon, Text, Title, FlexBox, Button, Label, ResponsiveGridLayout } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { getItem } from '../../utils/storageUtils';

const Profile = () => {
    const { t } = useTranslations();
    const user = getItem('user');
    const location = window.location.host;

    return (
        <FlexBox
            data-testid="profile-component"
            direction="Column"
            style={{
                ...uiFullWidth,
                ...uiFullHeight,
            }}
        >
            <FlexBox className="profile-heading" style={{ ...uiFullWidth, padding: ThemingParameters.sapContent_Margin_Medium }} alignItems="Center">
                <Icon
                    name="sap-icon://person-placeholder"
                    style={{
                        marginRight: ThemingParameters.sapContent_Margin_Small,
                        ...uiButtonIconMediumSize,
                        color: ThemingParameters.sapContent_IconColor,
                    }}
                />
                <Title
                    level="H5"
                    style={{ fontSize: ThemingParameters.sapFontHeader5Size, color: ThemingParameters.sapPageHeader_TextColor, fontWeight: '900' }}
                >
                    {user?.given_name} {user?.family_name}
                </Title>
            </FlexBox>

            <ResponsiveGridLayout
                columnsXL={2}
                columnsL={2}
                columnsM={2}
                columnsS={2}
                className="ui5-grid-profile"
                style={{ alignItems: 'center', justifyContent: 'center', padding: ThemingParameters.sapContent_Margin_Small }}
            >
                <Text
                    data-testid="profile-name"
                    style={{ color: ThemingParameters.sapContent_LabelColor, fontSize: ThemingParameters.sapFontSize, textAlign: 'right' }}
                >
                    {t('NAME')}:
                </Text>
                <Label
                    data-testid="profile-name-data"
                    style={{
                        color: ThemingParameters.sapField_TextColor,
                        fontSize: ThemingParameters.sapFontSize,
                    }}
                >
                    {user?.given_name} {user?.family_name}
                </Label>

                <Text data-testid="profile-email" style={{ color: ThemingParameters.sapContent_LabelColor, textAlign: 'right' }}>
                    {t('EMAIL')}:
                </Text>
                <Label
                    data-testid="profile-email-data"
                    style={{
                        color: ThemingParameters.sapField_TextColor,
                        fontSize: ThemingParameters.sapFontSize,
                    }}
                >
                    {user?.mail}
                </Label>
                <Text data-testid="profile-server" style={{ color: ThemingParameters.sapContent_LabelColor, textAlign: 'right' }}>
                    {t('SERVER')}:
                </Text>
                <Label
                    data-testid="profile-server-data"
                    style={{
                        color: ThemingParameters.sapField_TextColor,
                        fontSize: ThemingParameters.sapFontSize,
                    }}
                >
                    {location}
                </Label>

                <FlexBox
                    className="personalization"
                    direction="Column"
                    justifyContent="Start"
                    gap={8}
                    style={{ marginTop: ThemingParameters.sapContent_Margin_Small }}
                >
                    <Label
                        style={{
                            color: ThemingParameters.sapContent_LabelColor,
                            marginBottom: '0.5rem',
                            fontSize: ThemingParameters.sapFontSize,
                        }}
                    >
                        {t('PERSONALIZATION')}
                    </Label>
                    <div>
                        <Button>{t('RESET_PERSONALIZATION_BUTTON')}</Button>
                    </div>
                </FlexBox>

                <FlexBox style={{ ...uiFullWidth, gridColumn: 'span 2' }} direction="Column" className="footer">
                    <hr
                        style={{
                            ...uiFullWidth,
                            borderTop: 'none',
                            borderColor: `${ThemingParameters.sapGroup_ContentBorderColor}`,
                            borderWidth: '2px',
                        }}
                    />
                    <Text
                        style={{
                            color: ThemingParameters.sapContent_LabelColor,
                            fontStyle: 'italic',
                            marginTop: ThemingParameters.sapContent_Margin_Small,
                            fontSize: ThemingParameters.sapFontSmallSize,
                            gridColumn: 'span 2',
                        }}
                    >
                        {t('SAVE_SETTING_MESSAGE')}
                    </Text>
                </FlexBox>
            </ResponsiveGridLayout>
        </FlexBox>
    );
};

export default Profile;
